import { Controller } from "stimulus";

// Dropdown combobox with built-in search and Turbo Frame results.
//
// The trigger is a <button> that looks like a native <select>.
// When opened, a search <input> inside the dropdown panel
// auto-focuses and filters results via Turbo Frame.
//
export default class extends Controller {
  static targets = ['label', 'value', 'input', 'frame', 'clear'];

  connect() {
    this._timer = null;
    this._onOutsideClick = this._handleOutsideClick.bind(this);
    document.addEventListener('click', this._onOutsideClick, true);
  }

  disconnect() {
    document.removeEventListener('click', this._onOutsideClick, true);
    clearTimeout(this._timer);
  }

  // Toggle dropdown open/closed
  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.element.classList.contains('is-active')) {
      this._close();
    } else {
      this._open();
    }
  }

  // Debounced search on input
  search() {
    clearTimeout(this._timer);
    this._timer = setTimeout(() => this._load(), 250);
  }

  // User clicks a result
  pick(event) {
    event.preventDefault();
    var el = event.currentTarget;
    this.valueTarget.value = el.dataset.value;
    this.labelTarget.textContent = el.dataset.label;
    this.labelTarget.classList.remove('has-text-grey');
    this._close();
    this._refreshClear();
  }

  // Clear selection
  clear(event) {
    event.preventDefault();
    event.stopPropagation();
    this.valueTarget.value = '';
    this.labelTarget.textContent = this.data.get('placeholder') || 'Select...';
    this.labelTarget.classList.add('has-text-grey');
    this._close();
    this._refreshClear();
  }

  // ── private ──────────────────────────────────────────────────────────

  _open() {
    this._load();
    this.element.classList.add('is-active');
    // Auto-focus the search input after dropdown opens
    requestAnimationFrame(() => {
      if (this.hasInputTarget) this.inputTarget.focus();
    });
  }

  _close() {
    this.element.classList.remove('is-active');
    // Reset search field so next open shows full list
    if (this.hasInputTarget) this.inputTarget.value = '';
  }

  _load() {
    var url     = this.data.get('url');
    var frameId = this.data.get('frame-id');
    var q       = this.hasInputTarget ? encodeURIComponent(this.inputTarget.value || '') : '';
    this.frameTarget.src = url + '&q=' + q + '&frame_id=' + encodeURIComponent(frameId);
  }

  _handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this._close();
    }
  }

  _refreshClear() {
    if (this.hasClearTarget) {
      this.clearTarget.classList.toggle('is-hidden', !this.valueTarget.value);
    }
  }
}
